/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  GamoraBase64URLGuard,
  GamoraErrorUnhandledException,
  assert,
} from '@ver.id/libs.internal.gamora';
import { HoruzProtocolChulakDataType } from '../../data.js';
import { HoruzProtocolChulakMessageGuard } from './base.js';

/**
 * Input type
 * @public
 */
export interface HoruzProtocolChulakMessageAgentStartCompletedGuardInput {}

/**
 * @public
 */
export class HoruzProtocolChulakMessageAgentStartCompletedGuard extends HoruzProtocolChulakMessageGuard<
  HoruzProtocolChulakDataType.DATA_AGENT_START_COMPLETED,
  HoruzProtocolChulakMessageAgentStartCompletedGuardInput
> {
  /**
   * Constructor
   * @param input - the input
   */
  constructor(input: HoruzProtocolChulakMessageAgentStartCompletedGuardInput) {
    super();
  }

  /**
   * Gets type
   */
  get type(): HoruzProtocolChulakDataType.DATA_AGENT_START_COMPLETED {
    return HoruzProtocolChulakDataType.DATA_AGENT_START_COMPLETED;
  }

  /**
   * Gets from JSON
   * @param input - Input string
   */
  static override fromJSON(
    input: unknown,
  ): HoruzProtocolChulakMessageAgentStartCompletedGuard {
    assert(
      typeof input === 'object' && input !== null,
      'Invalid input argument: not an object.',
    );
    return new HoruzProtocolChulakMessageAgentStartCompletedGuard(
      input as HoruzProtocolChulakMessageAgentStartCompletedGuardInput,
    );
  }

  /**
   * Get from base64URL
   * @param input - The input
   */
  static override fromBase64URL(
    input: unknown,
  ): HoruzProtocolChulakMessageAgentStartCompletedGuard {
    assert(
      typeof input === 'string' && input.length > 0,
      'Invalid input argument: not a valid string.',
    );

    // Parse input
    let json;
    try {
      json = JSON.parse(GamoraBase64URLGuard.fromBase64URL(input).toUTF8());
    } catch (e) {
      throw new GamoraErrorUnhandledException(
        'Unable to parse input: not valid JSON in base64url input.',
      );
    }

    // Create new guard
    return new HoruzProtocolChulakMessageAgentStartCompletedGuard(
      json as HoruzProtocolChulakMessageAgentStartCompletedGuardInput,
    );
  }

  /**
   * Gets JSON
   * @returns string
   */
  override toJSON() {
    return {};
  }

  /**
   * To Base64URL
   */
  override toBase64URL(): string {
    const json = this.toJSON();
    return GamoraBase64URLGuard.fromUTF8(JSON.stringify(json)).toBase64URL();
  }

  /**
   * Create clone
   */
  clone() {
    return HoruzProtocolChulakMessageAgentStartCompletedGuard.fromJSON(
      this.toJSON(),
    );
  }
}
